export const FETCH_ALL_LOCATIONS = "FETCH_ALL_LOCATIONS";
export const CLEAR_ALL_FILTERS = "CLEAR_ALL_FILTERS";
export const ROWS_COUNT_AFTER_FILTER = "ROWS_COUNT_AFTER_FILTER";
export const IS_EDITED = "IS_EDITED";
export const SAVE_EDITS = "SAVE_EDITS";
export const SHOW_LOADER = "SHOW_LOADER"; 
export const DISCARD_CHANGES = "DISCARD_CHANGES";
export const ADD_NEW_LOCATION = "ADD_NEW_LOCATION";
export const DELETE_LOCATION = "DELETE_LOCATION";

